/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Hotel } from './Hotel';
import {
    HotelFromJSON,
    HotelFromJSONTyped,
    HotelToJSON,
    HotelToJSONTyped,
} from './Hotel';

/**
 * 
 * @export
 * @interface TripHotels
 */
export interface TripHotels {
    /**
     * 
     * @type {Array<Hotel>}
     * @memberof TripHotels
     */
    items?: Array<Hotel>;
}

/**
 * Check if a given object implements the TripHotels interface.
 */
export function instanceOfTripHotels(value: object): value is TripHotels {
    return true;
}

export function TripHotelsFromJSON(json: any): TripHotels {
    return TripHotelsFromJSONTyped(json, false);
}

export function TripHotelsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripHotels {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(HotelFromJSON)),
    };
}

export function TripHotelsToJSON(json: any): TripHotels {
    return TripHotelsToJSONTyped(json, false);
}

export function TripHotelsToJSONTyped(value?: TripHotels | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(HotelToJSON)),
    };
}

